import React from "react";
import { formatDate } from "../utils/helpers";
import "./FestivalModal.css";

const formatFestivalDate = (value) =>
  `${new Date(`${value}T00:00:00`).toLocaleDateString("en-IN", { weekday: "short" })}, ${formatDate(value)}`;

function FestivalModal({ festivals, currentIstTime, onClose }) {
  return (
    <div className="festival-modal">
      <div className="festival-modal__backdrop" onClick={onClose} />
      <div className="festival-modal__panel">
        <div className="festival-modal__header">
          <div>
            <span className="festival-modal__label">India Calendar</span>
            <h2>Upcoming Festivals</h2>
            <p>Current IST time: {currentIstTime}</p>
          </div>
          <button className="festival-modal__close" onClick={onClose}>
            X
          </button>
        </div>

        {festivals.length === 0 && <p className="festival-modal__empty">No upcoming festival found.</p>}

        {festivals.length > 0 && (
          <div className="festival-modal__list">
            {festivals.map((festival) => (
              <article className="festival-modal__item" key={festival._id}>
                <div>
                  <span className="festival-modal__tag">{festival.category}</span>
                  <h3>{festival.name}</h3>
                  <p>{festival.description || "Upcoming holiday or festival."}</p>
                </div>
                <strong>{formatFestivalDate(festival.date)}</strong>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default FestivalModal;
